(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = listSelectDelegate

var debug = require('./debug')('list select delegate')

/*
 * Facilitates the selecting on items in a list view.
 * Call listSelectDelegate with the context of the view,
 * e.g listSelectDelegate.call(this)
 * This function returns a collection that will maintain an
 * active set of the currently selected items.
 *
 * One assumption is made about the list view, which is
 * that list items are stored at `this.collection`.
 *
 * Usage:
 *
 * model.trigger('select', model)
 *   Adds a model to the selection. Model must exist in `this.collection`.
 *
 * model.trigger('deSelect', model)
 *   Removes a model from the selection.
 *
 * listView.trigger('clearSelection')
 *   Empties the selected collection.
 *
 * listView.trigger('addToSelection')
 *   Adds all of the models in `this.collection` to the selected collection.
 *
 * Listen to 'add' and 'remove' events if you want to keep track of
 * the size of the collection.
 */
function listSelectDelegate () {

  // A plain collection just to store the selected models in
  var selectedCollection = new Backbone.Collection()

  /*
   * Triggers a 'select' event on all of the models
   * in `this.collection`, causing them to be added
   * to the selected collection.
   */
  function addToSelection () {
    this.collection.each(function (model) {
      model.trigger('select', model)
    })
  }

  /*
   * Triggers a 'deSelect' event on all of the models in
   * the selected collection, causing them to be removed.
   */
  function clearSelection () {
    // Need to clone the array of models so that the
    // each loop completes.
    var models = selectedCollection.clone()
    models.forEach(function (model) {
      model.trigger('deSelect', model)
    })
  }

  // Hook up the functions to events on the view
  this.on('addToSelection', addToSelection)
  this.on('clearSelection', clearSelection)

  /*
   * Handle a 'select' event that contains a model, adding it to
   * the selected collection.
   */
  function select (model) {
    selectedCollection.add(model)
    debug('selecting', model, selectedCollection)
  }

  /*
   * Handle a 'deSelect' event that contains a model
   * removing it from the selected collection.
   */
  function deSelect (model) {
    selectedCollection.remove(model)
    debug('deselecting', model, selectedCollection)
  }

  // Wire up the functions to events on the collections
  this.listenTo(this.collection, 'select', select)
  this.listenTo(selectedCollection, 'deSelect', deSelect)

  return selectedCollection

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/list-select-delegate.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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